import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseProductInterface } from '../+models';

export const PURCHASE_PRODUCT_SERVICE_TOKEN = new InjectionToken('PurchaseProductServiceInterface');

export interface PurchaseProductServiceInterface {
  getAllForUser(userId: number): Observable<PurchaseProductInterface[]>;
}
